export default "__VITE_ASSET__BXxen9f3__"